export interface EquipmentRentalAvailabilityLocation {
  div_name: string;
  div_sort: string;
  on_contract: number;
  ready: number;
  not_ready: number;
}

export interface EquipmentRentalAvailability {
  availability_in_group: EquipmentRentalAvailabilityLocation[];
}
